function getRecipients({ path = '/recipients', data }) {
  return this.axios.post(path, data)
}

const recipients = (axios) => ({ axios, getRecipients })

export default recipients
